import { createContext, useContext } from 'react';
import { UseDevPanelState, DEFAULT_USE_DEV_PANEL_STATE } from '../hooks/useDevPanel';

export const DevPanelContext = createContext<UseDevPanelState>(DEFAULT_USE_DEV_PANEL_STATE);

export const useDevPanelContext = () => useContext(DevPanelContext);
